import React from "react";
import CkEditorField from "CommonComponent/CkEditorField/CkEditorField";


const DevelopmentPlanTab = ({ formState, updateFormField, onNext, hasNextTab = false, onCancel, isReadOnly = false }) => {
  return (
    <>
      <div>
        <div className="alert-comment">
          <img
            src="/assets/images/information-alert-icon.svg"
            alt=""
            className="me-2"
          />
          <p className="mb-0 font-13 font-weight-s-bold">
            Developmental Plan:​{" "} <br />
            <span className="font-weight-normal">
              Indicate specific areas for improvement or attention which may increase effectiveness in current position or aid in future opportunities. Identify skills or training the individual should obtain to prepare for additional responsibilities and/or achievement of goals.
            </span>{" "}
          </p>
        </div>
        <div className="my-3">
          <p className="font-13 font-weight-normal heading-color mb-2">
            Comments
          </p>
          <CkEditorField
            data={formState?.developmentalPlan || ""}
            disabled={isReadOnly}
            readOnly={isReadOnly}
            onChange={(html) => updateFormField("developmentalPlan", html)}
          />
        </div>
        <div>
          {onCancel && <button type="button" className="c-b-btn" onClick={onCancel}>Cancel</button>}
          {onNext && (
            <button type="button" className="n-u-btn ms-2" onClick={onNext} disabled={!hasNextTab}>
              Next
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default DevelopmentPlanTab;
